import { Suspense, useEffect } from "react";
import { lazyWithReload } from "@/lib/lazyWithReload";
import { Hero } from "@/components/Hero";
import { Experience } from "@/components/Experience";
import { Skills } from "@/components/Skills";
import { Certifications } from "@/components/Certifications";
import { MobileApps } from "@/components/MobileApps";
import { Projects } from "@/components/Projects";
import { Reveal } from "@/components/Reveal";
import { resetToDefaultMetaTags } from "@/lib/metaUtils";

// Sanity client is heavy and Blogs sits at the bottom of the page
const Blogs = lazyWithReload(() => import("@/components/Blogs").then((m) => ({ default: m.Blogs })));

const Index = () => {
  useEffect(() => {
    // Ensure default meta tags are set for homepage
    resetToDefaultMetaTags();
  }, []);

  return (
    <div className="min-h-screen">
      <main>
        <Hero />
        <Reveal order={0}><Experience /></Reveal>
        <Reveal order={1}><Skills /></Reveal>
        <Reveal order={2}><Certifications /></Reveal>
        <Reveal order={3}><MobileApps /></Reveal>
        <Reveal order={4}><Projects maxProjects={4} /></Reveal>
        <Suspense fallback={null}><Reveal order={5}><Blogs /></Reveal></Suspense>
      </main>
    </div>
  );
};

export default Index;
